import { createMuiTheme } from '@material-ui/core/styles';
import grey from '@material-ui/core/colors/grey';

// Extend default MuiTheme
const Default = createMuiTheme({
  palette: {
    primary: {
      main: '#C27F49',
    },
  },
  overrides: {
    MuiBackdrop: {
      root: {
        color: '#C27F49',
      },
    },
    MuiFormHelperText: {
      contained: {
        marginLeft: 0,
        marginRight: 0,
      },
    },
    MuiTableHead: {
      root: {
        background: grey[100],
      },
    },
    MuiTableCell: {
      head: {
        fontWeight: 'bold',
      },
    },
    MuiTableSortLabel: {
      icon: {
        opacity: 1,
        color: 'rgba(0, 0, 0, 0.54)',
      },
    },
  },
});

export default Default;
